import { MiddlewareProps } from '../utils';
import { isInternal } from '../../../authentication/utils';

export const sourceMiddleware = ({ payload, next }: MiddlewareProps) => {
  if (isInternal(payload?.obj)) {
    delete payload.obj.integrations.Amplitude;
  }

  next(payload);
};

export const applySourceMiddleware = () => {
  const analytics = global['analytics'];
  if (analytics.sourceMiddlewareApplied) {
    return;
  }

  const isMiddlewareExists = analytics.queue?.plugins?.find(
    (plugin: any) => plugin.name.toLowerCase() === `source middleware ${sourceMiddleware.name}`.toLowerCase()
  );
  if (!isMiddlewareExists) {
    analytics.addSourceMiddleware(sourceMiddleware);
  }

  analytics.sourceMiddlewareApplied = true;
};
